import axios from '../utils/index'

// 前台查询已有栏目接口
export function listRecommendColumn(params) {
  return axios.post('/portal/recommend/listRecommendColumn', params)
}

// 前台列表查询推荐资源接口
export function listRecommend(params) {
  return axios.post('/portal/recommend/listRecommend', params)
}

// 前台列表首页查询推荐资源接口
export function listHomePageRecommend(params) {
  return axios.post('/portal/recommend/listHomePageRecommend', params)
}
